import React from "react";
import { RectangleGroupIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";

/**
 * 메뉴/페이지 타이틀 공용 컴포넌트
 * @param {React.ReactNode} [icon] - 타이틀 앞 아이콘 (미지정 시 기본 RectangleGroupIcon 사용)
 * @param {string} title - 타이틀 텍스트
 * @param {string} [className] - 컨테이너 추가 클래스
 * @param {string} [iconClassName] - 아이콘 추가 클래스 (기본: w-5 h-5 text-blue-600)
 * @param {React.ReactNode} [children] - 타이틀 오른쪽 액션(버튼 등)
 */
export function PageTitle({ icon: Icon = RectangleGroupIcon, title, className, iconClassName, children }) {
  return (
    <div className={clsx("flex items-center justify-between", className)}>
      <h1 className="text-base font-semibold text-gray-800 flex items-center gap-2">
        <Icon className={clsx("w-5 h-5 text-blue-600 shrink-0", iconClassName)} />
        {title}
      </h1>
      {children ? <div className="flex items-center gap-2">{children}</div> : null}
    </div>
  );
}

export default PageTitle;
